import { getStateFromZipCode } from '@services';
import UtilityStore from 'src/stores/utilityStore';

const cacheTest = (
  asyncValidate: (val: string, store: UtilityStore) => Promise<boolean>
) => {
  let _valid = false;
  let _value = '';

  return async (value: string, store: UtilityStore) => {
    if (value !== _value) {
      const response = await asyncValidate(value, store);
      _value = value;
      _valid = response;
      return response;
    }
    return _valid;
  };
};

const validateStateAndZip = async (value: string, store: UtilityStore) => {
  if (value.length === 5) {
    const state = await getStateFromZipCode(value);
    if (state) store.setState(state);
    return !!state;
  }
  return true;
};

export const zipCodeValidation = cacheTest(validateStateAndZip);
